import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import FormFields from '../../../../../themes/admin/Fields/FormFields';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, md: 24, sm: 24, xs: 24 };

const Commission = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <FormFields.InputNumberField
                    {...t('financeProductDetails:fields.commission', { returnObjects: true })}
                    disabled={disabled}
                    max={100}
                    min={0}
                    name="commission.default"
                    precision={2}
                    required
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.commissionViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="commission.isViewable"
                />
            </Col>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.commissionEditable', { returnObjects: true })}
                    disabled={disabled}
                    name="commission.isEditable"
                />
            </Col>
        </Row>
    );
};

export default Commission;
